import { render, staticRenderFns } from "./overview-details.vue?vue&type=template&id=35baa33f&"
import script from "./overview-details.vue?vue&type=script&lang=js&"
export * from "./overview-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports